export default __webpack_public_path__ + "static/media/streaks 150.88bf6c5f.svg";